import { ImagePath } from '../../types';
import { FALLBACK_SRC } from './const';
import { MIN_PIXEL_RATIO } from '../../const';

export const createSrcByPixelRatio = (path: ImagePath, ratio: number) => {
  if (ratio < MIN_PIXEL_RATIO) {
    console.warn(
      '[create-src-by-pixel-ratio]: invalid ration parameter handled:',
      ratio
    );

    return FALLBACK_SRC;
  }

  return `${path} ${ratio}x, ${path} ${ratio}.5x`;
};
